<template>
  <form class="PASSWORD-FORM" @submit.prevent="submit">
    <div v-if="showTitle" class="h1 m-b-3" selenium="password-form-title">
      {{ titleText }}
    </div>

    <password-fields ref="passwordfields" :disabled="loading"/>

    <special-message ref="error" type="error" class="m-b-2" selenium="password-form-error">
      Failed to change password. Please try again later.
    </special-message>

    <special-message ref="success" type="success" class="m-b-2" selenium="password-form-success">
      Successfully updated password.
    </special-message>

    <button
        :disabled="loading"
        type="submit"
        class="btn w-100"
        selenium="password-form-button">
      {{ ctaText }}
    </button>
  </form>
</template>

<script>
import { updateMyPassword } from '@homeservices/api-kit/search/user';
import PasswordFields from '@/components/PasswordFields';
import SpecialMessage from '@/components/SpecialMessage';

export default {
  name: 'app-change-password-form',
  components: {
    PasswordFields,
    SpecialMessage,
  },
  props: {
    ctaText: {
      type: String,
      default: 'Save Password',
    },
    titleText: {
      type: String,
      default: 'Change Password',
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
    redirectTo: {
      type: [Object, String],
      default: '',
    },
  },
  data () {
    return {
      loading: false,
    };
  },
  methods: {
    async submit () {
      this.$refs.error.hide();

      const valid = await this.$refs.passwordfields.$validate();
      if (!valid) { return; }

      try {
        this.loading = true;
        await updateMyPassword({
          password: this.$refs.passwordfields.getPassword(),
        });
        if (this.redirectTo) {
          this.redirect();
        } else {
          this.$refs.success.trigger();
        }
      } catch (err) {
        this.$refs.error.trigger(10000);
      } finally {
        this.loading = false;
        this.$refs.passwordfields.reset();
      }
    },
    redirect () {
      if (typeof this.redirectTo === 'string') {
        window.location.href = this.redirectTo;
      } else {
        this.$router.push(this.redirectTo);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .PASSWORD-FORM {
    @include responsive(width, 100%, 350px);
  }
</style>
